function partnerCard() {
  const card = document.querySelectorAll('.partner-cards')

  card.forEach(e => {
    console.log(e.children.length)
    if (e.children.length == 3) {
      
      e.classList.add('partner-cards__col-3')
    } else if(e.children.length >= 4) {
      e.classList.add('partner-cards__col-4')
    }
  })
}


export { partnerCard }
